import { type InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  type GetIssueSLAs200Response,
  useApi,
  IssueSLAsFilteringDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export type UseInfiniteIssueSLAsParamsObject = {
  page?: number;
  limit?: number;
  filter?: IssueSLAsFilteringDtoOptions;
};

export interface UseInfiniteIssueSLAsParams {
  params?: UseInfiniteIssueSLAsParamsObject;
  enabled?: boolean;
}

export function useInfiniteIssueSLAs({
  params = {},
  enabled = true,
}: UseInfiniteIssueSLAsParams) {
  const { page = 0, limit = 10, filter } = params;

  const api = useApi();

  const queryKey = ['issue-slas', page, limit, filter, enabled];

  return useInfiniteQuery<
    GetIssueSLAs200Response,
    ExtendedAxiosError,
    InfiniteData<GetIssueSLAs200Response>,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: ({ pageParam }) =>
      api.issueSLAsApi
        .getIssueSLAs(filter, pageParam, limit)
        .then((r) => r.data),
    enabled,
    initialPageParam: page,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
  });
}
